import axios from "axios";

type IpInfoResponse = {
  ip?: string;
  city?: string;
  region?: string;
  country: string;
  loc?: string;
  org?: string;
  postal?: string;
  timezone?: string;
  readme?: string;
};

export const getCountry = async (): Promise<IpInfoResponse | null> => {
  try {
    const response = await axios.get<IpInfoResponse>("https://ipinfo.io/json");
    return response.data;
  } catch {
    return null;
  }
};
